import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navItems = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Tools',
    href: '#tools'
  }, {
    name: 'Brands',
    href: '#brands'
  }, {
    name: 'Impact',
    href: '#impact'
  }, {
    name: 'Newsletter',
    href: '#newsletter'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <motion.nav className="fixed top-0 left-0 w-full z-50 bg-white shadow-md py-2" initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-105">
      <div className="container max-w-6xl mx-auto px-4 flex justify-between items-center" data-id="element-106">
        <a href="#" className="text-xl font-bold text-gray-900" data-id="element-107">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ob5vR671tpXcY4B7w7b8js/lgo_andre.png" alt="Andrew Igbineweka" className="h-10 w-auto" data-id="element-108" />
        </a>
        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-109">
          {navItems.map(item => <a key={item.name} href={item.href} className="text-gray-700 hover:text-gray-900 font-medium transition-colors duration-200" data-id="element-110">
              {item.name}
            </a>)}
        </div>
        {/* Mobile Navigation Toggle */}
        <button className="md:hidden text-gray-700 hover:text-gray-900 focus:outline-none" onClick={toggleMenu} aria-label="Toggle menu" data-id="element-111">
          {isOpen ? <X size={24} data-id="element-112" /> : <Menu size={24} data-id="element-113" />}
        </button>
      </div>
      {/* Mobile Navigation Menu */}
      {isOpen && <motion.div className="md:hidden bg-white w-full shadow-lg" initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} exit={{
      opacity: 0,
      height: 0
    }} transition={{
      duration: 0.3
    }} data-id="element-114">
          <div className="container mx-auto py-4 px-4 flex flex-col space-y-4" data-id="element-115">
            {navItems.map(item => <a key={item.name} href={item.href} className="text-gray-700 hover:text-gray-900 font-medium py-2 transition-colors duration-200" onClick={() => setIsOpen(false)} data-id="element-116">
                {item.name}
              </a>)}
          </div>
        </motion.div>}
    </motion.nav>;
}